import React from 'react';
import { ThumbnailUtils } from '@@Storefront';
import { Title, Subtitle, ContentWrapper, ImageContainer, ContentContainer, TextContentContainer, StyledButton } from './styled';
export const ImageText = ({ subtitle, title, content, buttons, imagePosition, absolutePath, imageUrl, }) => {
    const reverseImage = imagePosition === 'right';
    const isMobile = window.innerWidth < 900;
    return (React.createElement(ContentWrapper, { reverse: reverseImage },
        React.createElement(TextContentContainer, { reverse: reverseImage },
            subtitle && React.createElement(Subtitle, null, subtitle),
            title && React.createElement(Title, null, title),
            content && React.createElement(ContentContainer, null, content),
            buttons && buttons.map((button, index) => (button.content && button.url && (React.createElement("a", { href: button.url, key: index },
                React.createElement(StyledButton, { isMobile: button === null || button === void 0 ? void 0 : button.isMobile, appearance: button === null || button === void 0 ? void 0 : button.appearance }, button === null || button === void 0 ? void 0 : button.content)))))),
        React.createElement(ImageContainer, null,
            React.createElement("img", { alt: title || undefined, title: title || undefined, src: absolutePath
                    ? imageUrl
                    : ThumbnailUtils.getImageSrc({
                        image: imageUrl,
                        width: 626,
                        height: 432,
                        fit: ''
                    }), width: "626", height: isMobile ? "auto" : "432", loading: "lazy" }))));
};
